"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/* istanbul ignore file */
var IStringHandler = /*#__PURE__*/function () {
  function IStringHandler() {
    (0, _classCallCheck2["default"])(this, IStringHandler);
  }
  return (0, _createClass2["default"])(IStringHandler, [{
    key: "format",
    value: function format() {}
  }, {
    key: "validate",
    value: function validate() {}
  }]);
}();
module.exports = IStringHandler;